import Deffered from '@tgtg/core/async/Deffered';
import { type Hash } from 'history';
import { router } from 'src/core/Router';

import { CHANGE_PASSWORD_PATH, LOGIN_PATH } from '../../../core/paths/paths';

import tokenLoginMatcher from './tokenLoginMatcher';
import TokenLoginResource from './TokenLoginResource';

import type { Session } from '@tgtg/core/session';

const PLUGIN_NAME = 'TOKEN_LOGIN';

function tokenLoginPluginCreator(hash: Hash): () => Promise<unknown> {
  const params = tokenLoginMatcher(hash);
  return function tokenLoginPlugin(): Promise<unknown> {
    if (!params?.token) return Promise.reject();

    const dfd = new Deffered();
    const { token } = params;
    TokenLoginResource.login(token)
      .then((session: Session | null) => {
        dfd.resolve({
          name: PLUGIN_NAME,
          session,
        });
        router.navigate(CHANGE_PASSWORD_PATH, {
          replace: true,
          state: { resetPasswordToken: token },
        });
      })
      .catch(() => {
        dfd.resolve({
          name: PLUGIN_NAME,
        });
        router.navigate(LOGIN_PATH, { replace: true, state: { tokenInvalid: true } });
      });

    return dfd.promise;
  };
}

export default tokenLoginPluginCreator;
